
import { defineComponent } from "vue";
import { currencyFormat } from "../assets/js/paydownData";
import { DebtAccount } from "../interfaces";

export default defineComponent({
  name: "AccountItem",
  emits: ["update", "delete", "clicked"],
  props: {
    account: {
      type: Object as () => DebtAccount,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    emitUpdate(id: string) {
      this.$emit("update", id);
    },
    emitDelete(id: string) {
      this.$emit("delete", id);
    },
    formatCurrency(value: number) {
      return currencyFormat(value);
    }
  }
});
